import { render, staticRenderFns } from "./all-project.pug?vue&type=template&id=6f708bfe&lang=pug&"
import script from "./all-project.ts?vue&type=script&lang=ts&"
export * from "./all-project.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports